/* Copyright (c) 2025 Xperi. All Rights Reserved.  */

import { BrandingUiInfoKeys } from '../../../../core/entities';
import { ServicesClientImpl } from '../../../../core/interactors';
import { Locale, LocaleKeys } from '../../../../core/locale';

import './Footer.scss';

interface IFooterProps {
    shouldShowRightMessage?: boolean;
}

export const Footer = ({ shouldShowRightMessage = false }: IFooterProps) => {
    const services = new ServicesClientImpl();

    const secondaryBranding = services.getAppUiImageByKey(
        BrandingUiInfoKeys.APP_ICONS.SECONDARY_BRANDING,
    );

    return (
        <div className="footer-container">
            <img className="footer-branding-icon" src={secondaryBranding?.imageUrl} />
            {shouldShowRightMessage && (
                <div className="footer-select-and-all-channels-text">
                    <span>
                        {Locale.getString(LocaleKeys.RECORDING_FOOTER_PRESS_AND_HOLD_MESSAGE)}
                    </span>
                </div>
            )}
        </div>
    );
};
